import { ScaleAnswerTypeDto } from '@/api/generated';

type Questions = {
  titles: Record<number, string>;
  content: Record<number, string>;
};

export type QuizQuestionsTranslations = {
  scaleQuestions: {
    scale2: Record<ScaleAnswerTypeDto, string>;
    scale3: Record<ScaleAnswerTypeDto, string>;
  };
  buttons: {
    next: string;
    skip: string;
  };
  energyTable: {
    energyConsumption: string;
    office: string;
    renewableSources: string;
    warsaw: string;
  };
  questions: Record<number, Questions>;
};

export const quizQuestionsTranslations: QuizQuestionsTranslations = {
  scaleQuestions: {
    scale3: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Center]: 'B',
      [ScaleAnswerTypeDto.Right]: 'C',
    },
    scale2: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Right]: 'B',
      [ScaleAnswerTypeDto.Center]: '',
    },
  },
  buttons: {
    next: 'Dalej',
    skip: 'Pomiń',
  },
  energyTable: {
    energyConsumption: 'Średnie miesięczne zużycie energii (kWh)',
    office: 'Biuro',
    renewableSources: 'Odnawialne źródła energii (%)',
    warsaw: 'Warszawa',
  },
  questions: {
    1: {
      titles: {
        1: 'O… a tutaj to dzieje się nawet zbyt wiele.',
      },
      content: {
        1: 'Każdy chce dołączyć do najnowszej międzyplanetarnej misji na Marsa. Wiesz… prestiż, niezwykle ciekawy projekt, no i te widoki… Bajka! Nie ma zbyt wiele miejsc, a chętnych nigdy nie brakuje. ',
        2: 'Każda misja wymaga interdyscyplinarnych umiejętności, a w zespole musi być przedstawiciel każdego działu Orange.',
        3: 'Przykładowo: w dziale łączności międzyplanetarnej mamy dwóch kandydatów na jedno miejsce.',
        4: 'Co z tym zrobić? Pomożesz mi? Jak rozwiązać tę sytuację - zapobiec kłótniom i jednocześnie wzmocnić współpracę?',
      },
    },
    2: {
      titles: {
        1: 'Świetnie! Pierwsze zadanie za Tobą! Nie było to takie trudne i udało Ci się bez pomocy AI.',
      },
      content: {
        1: 'A skoro mowa o sztucznej inteligencji, już w Twoich czasach wiele mówiło się o odpowiedzialności i etycznych aspektach rozwoju AI. Teraz to równie istotne.',
        2: 'Ach! Przypomniało mi się, że mam tu do zrobienia ważną rzecz! Dostałem zaproszenie do testowania pilotażowej wersji nowego narzędzia z technologią AI, którego już wkrótce będą używać wszyscy w naszej organizacji. Będzie to ważna zmiana dla firmy, bo umożliwi nam komunikację w formie hologramów i usprawni współpracę między zespołami. Jeśli zdecyduję się wziąć udział w pilocie, muszę znaleźć czas na szkolenie wstępne, testowanie i udzielanie informacji zwrotnej zespołowi wdrażającemu. A czas nie jest z gumy...',
      },
    },
    3: {
      titles: {
        1: 'Dzięki za radę! Tak zrobię!',
        2: 'Cenimy sobie bezpośredniość i - tak jak pracownicy w Orange - mówimy do siebie po imieniu, tym ludzkim.',
        3: 'Ale żarty na bok. Jest sprawa, w której musisz mi pomóc. Dasz radę, prawda?',
      },
      content: {
        1: 'W ramach podziękowań mam dla Ciebie żart.',
        2: `Dwa roboty spotykają się w firmowej kuchni. <br/> Jeden z nich mówi: <br/> - Cześć, jestem Model-TRX-4987-Quantum-Unit-Alpha.<br/> - O, rany! – odpowiada drugi - A mogę mówić do ciebie jakoś inaczej?<br/> - Spoko, mów mi Krzychu.`,
        3: 'W jednym z zespołów pojawił się problem. Jest kilka robotów, które wykonują kawał świetnej roboty ;) Inne często się zawieszają – nie dosłownie, ale w przenośni i ich praca nie jest już tak wydajna. Wstępne rozmowy z zespołem wskazały, że coś nie gra w obszarze motywacji, ale nie wiadomo dokładnie co. Jak możemy rozwiązać tę sytuację?',
      },
    },
    4: {
      titles: {
        1: 'No! I to jest myśl! Ok, czas teraz wrócić na Ziemię.',
      },
      content: {
        1: 'Czeka tam na nas wiele pracy. Portal otworzy się już za chwilę. Co za ironia – trzeba poczekać na podróż w czasie. No ale co zrobić – takie mamy… czasy. Haha!',
        2: 'W Twojej epoce praca wyglądała nieco inaczej, prawda? Dużo ręcznego pisania, analizowania, szukania... Uff, męczące. </br> Ale w Orange mieliście już wtedy coś, co było prawdziwą rewolucją. Coś, co moi cyfrowi przodkowie nazwaliby „game changerem". Mowa o Dinootoo. To nie był zwykły program, ale potężna platforma generatywnej sztucznej inteligencji dostępna dla każdego pracownika!',
        3: 'Wiedziałem, że masz nosa do technologii! Dinootoo to było autorskie narzędzie Orange – bezpieczna brama do wiedzy tamtych czasów. </br>Dawało dostęp do kilkunastu modeli LLM znanych na całym świecie, takich jak Chat GPT czy Gemini, ale w bezpiecznym, firmowym środowisku. Wyobraź sobie: masz jednego asystenta, który łączy wiedzę i możliwości ich wszystkich. Możesz z nim rozmawiać, zadawać pytania, czy przesyłać pliki, żeby błyskawicznie wyciągnął z nich to, co najważniejsze.</br>Ale to tylko wierzchołek góry lodowej. Chcesz wiedzieć, w czym konkretnie Dinootoo wyręczało pracowników na co dzień?',
        4: 'No to słuchaj, bo to brzmi jak magia, a w Twoich czasach było codziennością! Dinootoo było mistrzem od żmudnej roboty. Musisz napisać trudnego maila w zgodzie z zasadami prostego języka? Dinootoo robi to w kilka sekund. Potrzebujesz podsumowania długiego raportu lub notatki ze spotkania? Pyk – gotowe. A może ćwiczenie feedbacku, strukturyzowanie prezentacji, generowanie obrazów czy nawet pomoc w pisaniu kodu? Dla Dinootoo to była pestka. Dzięki temu ludzie odzyskiwali czas na to, co w pracy najważniejsze – kreatywność i rozwój, zamiast tonąć w rutynie. Ale mieliście tam jeszcze jedną, superzaawansowaną funkcję, która pozwalała „klonować” pomocników. Chcesz usłyszeć o tej wisience na torcie?',
        5: 'Tą supermocą była możliwość tworzenia własnych asystentów. W Dinootoo każdy mógł zbudować dedykowanego pomocnika, zaprogramowanego do wspierania w bardzo konkretnych czynnościach, a potem... udostępnić go innym w zespole! To tak, jakby stworzyć eksperta od jednej dziedziny, który pracuje dla wszystkich 24/7. To właśnie dzięki takim narzędziom praca w Orange stała się lżejsza, efektywniejsza i po prostu... fajniejsza. Wykorzystywaliście AI, żeby mieć więcej przestrzeni na bycie ludźmi.',
        6: 'Piękna sprawa, ale wystarczy tych nostalgicznych wycieczek. Portal jest już aktywny! Wskakujmy!',
      },
    },
    5: {
      titles: {
        1: 'O, widzę, że po drodze wpadliśmy na kultowy Orange Warsaw Festival. Może zatańczymy robo dance?',
      },
      content: {
        1: 'Czy wiesz, że także w branży muzycznej wykorzystuje się najnowocześniejsze technologie? Dzięki temu możemy jeszcze mocniej przeżywać wydarzenia kulturalne. Wystarczy wspomnieć chociażby o Augmented Reality, do której świetnie nadaje się sieć 5G.',
        2: 'Aktualnie organizatorzy zastanawiają się nad nazwą nowej technologii, która będzie w tym roku po raz pierwszy wykorzystana na festiwalu. Ta technologia pozwoli poczuć muzykę całym ciałem! To będzie czad! Tylko... jak moglibyśmy ją nazwać?',
      },
    },
    6: {
      titles: {
        1: 'Dobrze! Koncerty pozostawmy gwiazdom, my lecimy do biura.',
      },
      content: {
        1: 'Oho, czuć tu napiętą atmosferę. Zdaje się, że ktoś przed chwilą pozwolił sobie na niestosowny żart.',
      },
    },
    7: {
      titles: {
        1: 'Świetnie! Dobrze mieć w swoim teamie kompetentnego człowieka.',
      },
      content: {
        1: 'A skoro mowa o kompetencjach, powiedz mi, jak się o nich myśli w Twoich czasach?',
      },
    },
    8: {
      titles: {
        1: 'Słyszysz? Czy to dźwięki koncertu?',
      },
      content: {
        1: 'Chyba jednak to głosy organizatorów Orange Warsaw Festival. Zostały już tylko dwa dni i wciąż tak wiele rzeczy do zrobienia. Pomożesz im ustalić priorytety?',
      },
    },
    9: {
      titles: {
        1: 'No i wszystko gra! Chodźmy na spacer.',
      },
      content: {
        1: 'Czy wiesz, że działania Emilii oraz jej zespołu sprawiły, że wyrósł tu piękny las? Przyczyniło się to do realizacji kolejnego celu firmy - do zeroemisyjności.',
        2: 'Sadzenie lasów to nie jedyna rzecz, którą Orange robi troszcząc się o środowisko.',
      },
    },
    10: {
      titles: {
        1: 'To była trudna decyzja, ale Twoja sugestia okazała się w niej bardzo pomocna. Dzięki!',
      },
      content: {
        1: 'Jednak Emilia ma jeszcze jeden dylemat - za chwilę zaczyna spotkanie z zespołem i musi zakomunikować im dalszy plan działania. Wie, że to dobra decyzja, ale jednocześnie czuje spory stres, bo z pewnością będzie to dla nich trudny moment.\nJak może sobie z tym poradzić?',
      },
    },
    11: {
      titles: {
        1: 'Było gorąco, ale się udało! Zaczynamy spotkanie. Maciek, nasz kolega, zaprezentuje teraz wyniki naszych dotychczasowych działań.',
      },
      content: {
        1: 'Ups! Pogubił się jednak przy interpretacji danych i teraz trzeba to naprawić. Pomożesz?',
        2: `Maciek w trakcie swojej prezentacji powiedział: "Wczoraj przeprowadziliśmy badanie w gronie najbardziej lojalnych klientów, pytając, czy zgadzają się ze stwierdzeniem, że nasze działania mają znaczący wpływ na rozwiązanie problemu zmian klimatycznych. Spośród 15 osób biorących udział w badaniu, aż 12 potwierdziło naszą hipotezę. Myślę, że na tej podstawie możemy ogłosić duży sukces tego przedsięwzięcia!".`,
      },
    },
    12: {
      titles: {
        1: 'Poradziliśmy sobie ze sprostowaniami w prezentacji Maćka. Teraz czas na finał!',
      },
      content: {
        1: 'Jednym z działań, jakie podejmujemy w ramach naszego celu zeroemisyjności, jest zmniejszenie ilości energii zużywanej w biurach, pochodzącej z nieodnawialnych źródeł. ',
      },
    },
    13: {
      titles: {
        1: 'Świetnie! No i dotarliśmy na sam koniec wyzwania!',
        2: 'O? Czyżby? Tak! Działa!',
      },
      content: {
        1: 'To już prawie wszystkie zadania, które dla Ciebie przygotowałem. Czas wracać, portal już na nas czeka.',
        2: 'Mój cyber-kompas wartości działa teraz prawidłowo! To wszystko dzięki temu, że widziałem jak działasz i podejmujesz decyzje.',
        3: 'Teraz widzę już wyraźnie, że uważność to działania na rzecz klientów, współpraca i szacunek. Odpowiedzialność to doprowadzanie spraw do końca, transparentna komunikacja i dbanie o naszą planetę, a odwaga to szukanie nowych rozwiązań.',
        4: 'Przyszła pora na Twój odważny krok w stronę przyszłości. Mam nadzieję, że już wkrótce zyskasz możliwość udziału w naszych praktykach. ',
        5: 'Na koniec wypełnij jeszcze krótki formularz.',
        6: 'Ja już muszę lecieć. Bardzo miło było Cię poznać i mam nadzieję, że… do zobaczenia! Pa!',
      },
    },
  },
};
